export enum NotificationChannelEnum {
	EMAIL = 'EMAIL',
	WHATSAPP = 'WHATSAPP',
	TELEGRAM = 'TELEGRAM',
}
